import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Course } from "src/app/interfaces/response";
import { Router } from "@angular/router";
import { ComiteService } from "src/app/services/comite.service";

@Component({
  selector: "app-comite-table-principal",
  templateUrl: "./comite-table-principal.component.html",
  styleUrls: ["./comite-table-principal.component.css"],
})
export class ComiteTablePrincipalComponent implements OnInit {
  displayedColumns: string[] = ["comite", "sector", "date", "search"];
  dataSource = new MatTableDataSource<Course>();
  totalElements: number = 0;
  pageSize: number = 30;
  pageNumber: number = 0;
  code: string = "";
  filterTimeout: any;
  activeEror: boolean;
  debounceTimer: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() courseSelected = new EventEmitter<Course>();

  constructor(private service: ComiteService, private router: Router) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.getComites(this.pageNumber, this.pageSize, this.code);
  }

  public onPageChange(event: PageEvent): void {
    this.getComites(event.pageIndex, event.pageSize, this.code);
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.getComites(0, this.pageSize, filterValue);
    }, 800);
  }

  private async getComites(
    pageNumber: number,
    size: number,
    code: string
  ): Promise<void> {
    try {
      const comite = await this.service.getComites(pageNumber, size, code);
      if (!comite.content || comite?.content?.length === 0) {
        this.activeEror = true;
      } else {
        this.activeEror = false;
      }
      this.totalElements = comite.totalElements;
      this.dataSource.data = comite.content;
    } catch (error) {
      console.error("Error al obtener cursos:", error);
    }
  }

  public updateDate(date: any) {
    const fechaIntegracion = date;
    if (date) {
      const fecha = new Date(fechaIntegracion);
      const dia = fecha.getUTCDate().toString().padStart(2, '0'); // Día con dos dígitos
      const mes = (fecha.getUTCMonth() + 1).toString().padStart(2, '0'); // Mes con dos dígitos
      const anio = fecha.getUTCFullYear(); // Año
      const fechaFormateada = `${dia}/${mes}/${anio}`;
      return fechaFormateada;
    }
  }

  public sectorByID(data: any) {
    this.router.navigate(["/comite", data.idComite]);
  }
}
